import {gql} from '@apollo/client'

export const STAR_ITEMS = gql`
  mutation StarItems($input: ItemsInput!) {
    starItems(input: $input) {
      folderIds
      uploadIds
    }
  }
`

export const UNSTAR_ITEMS = gql`
  mutation UnstarItems($input: ItemsInput!) {
    unstarItems(input: $input) {
      folderIds
      uploadIds
    }
  }
`
